import ArchivedOrderListItem from '@/components/OrdersModule/OrderListItem/ArchivedOrderListItem'
import { useAppSelector } from '@/hooks/redux'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { FlashList, ListRenderItem } from '@shopify/flash-list'
import { FC, useCallback } from 'react'
import { createStyleSheet, useStyles } from 'react-native-unistyles'

const keyExtractor = (item: string): string => item

const ArchiveList: FC = () => {
    const uuids = useAppSelector(ordersSelectors.archivedOrderUuids)
    const selectedOrderUuid = useAppSelector(ordersSelectors.selectedOrderUuid)

    const renderItem: ListRenderItem<string> = useCallback(
        ({ item: uuid }) => (
            <ArchivedOrderListItem uuid={uuid} selected={uuid === selectedOrderUuid} />
        ),
        [selectedOrderUuid]
    )

    const { styles } = useStyles(stylesheet)

    return (
        <FlashList
            data={uuids}
            renderItem={renderItem}
            keyExtractor={keyExtractor}
            extraData={selectedOrderUuid}
            estimatedItemSize={64}
            showsVerticalScrollIndicator={false}
            contentContainerStyle={styles.contentContainer}
        />
    )
}

const stylesheet = createStyleSheet((_, runtime) => ({
    contentContainer: {
        paddingTop: 8,
        paddingBottom: runtime.insets.bottom,
    },
}))

export default ArchiveList
